// Currently this config returns values necessary for the application to run.

const defaultApiVersion = 1

const getEnvVar = (key: string): string => {
  const value = process.env[key]

  if (typeof value !== 'string' || value.trim() === '') {
    throw new Error(`Environment variable ${key} is missing or invalid`)
  }

  return value
}

const loadEnvironmentVariables = (): { apiUrl: string, userPoolId: string, clientId: string, courseFilesUrl: string } => {
  return {
    apiUrl: getEnvVar('REACT_APP_API_URL'),
    userPoolId: getEnvVar('REACT_APP_USER_POOL_ID'),
    clientId: getEnvVar('REACT_APP_CLIENT_ID'),
    courseFilesUrl: getEnvVar('REACT_APP_COURSE_FILES_URL')
  }
}

export enum Environment {
  DEVELOPMENT = 'development',
  STAGE = 'stage',
  PRODUCTION = 'production',
}

const environment = window.location.hostname === 'localhost'
  ? Environment.DEVELOPMENT
  : window.location.hostname === 'studio-app.dopa.ge'
    ? Environment.STAGE
    : Environment.PRODUCTION

const config = {
  baseUrl: process.env.REACT_APP_API_URL ?? 'https://studio-api.dopa.ge/api/', // URL used to connect to backend app that hosts APIs.  Refer to .env.example for detail on how this is et.
  apiVersion: defaultApiVersion,
  getAccountSlug: () => window.location.hostname === 'localhost' ? 'studio-app' : window.location.hostname.split('.')[0], // Dynamically reads the account name from the url, will pass this through to APIs.
  loadEnvironmentVariables,
  environment
}

export default config
